module.exports = __webpack_public_path__ + "static/apple-icon-114x114-aa3aa68056646326dc7a080f85e1f083.png";